import { defineComponent as t, resolveComponent as p, createBlock as s, openBlock as c, createSlots as i, renderList as m, withCtx as u, renderSlot as a, normalizeProps as f, guardReactiveProps as _ } from "vue";
import d from "./InputNumber-CJ1ZLzd0.js";
import { _ as l } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const $ = t({
  components: { TInputNumber: d },
  props: { precision: Number }
});
function b(e, I, N, C, P, T) {
  const o = p("TInputNumber");
  return c(), s(o, {
    min: 0,
    max: 1,
    step: 0.01,
    end: "%",
    scale: 100,
    precision: e.$props.precision ?? 2
  }, i({ _: 2 }, [
    m(e.$slots, (h, r) => ({
      name: r,
      fn: u((n) => [
        a(e.$slots, r, f(_(n ?? {})))
      ])
    }))
  ]), 1032, ["precision"]);
}
const B = /* @__PURE__ */ l($, [["render", b]]);
export {
  B as default
};
//# sourceMappingURL=InputNumberPercent-DghiTrSE.js.map
